import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Typography } from "@digital-services/ui";

// Note that <PageNotFound> from @digital-services/shell is used instead of this component now
// In future remove it
export const PageNotFound: FunctionComponent = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: "page-not-found"
  });

  return (
    <div data-testid="mife-shell-page-not-found-component">
      <div className="mx-auto flex max-w-[1600px] flex-col">
        <div className="flex flex-col gap-3">
          <Typography variant="pageTitle">{t("title")}</Typography>
          <Typography variant="description">{t("message")}</Typography>
        </div>
      </div>
    </div>
  );
};
